/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Selected_Event_TooltipInputs */

const en_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selected event to be timed. Hold down the up arrow key for the duration of time you want the event to display on screen.`)
};

const fr_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evenement selectionne a synchroniser. Maintenez la fleche vers le haut enfoncee pendant la duree d'affichage souhaitee.`)
};

const de_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ausgewählte Ereignis soll zeitlich angezeigt werden. Halten Sie die Pfeiltaste nach oben so lange gedrückt, wie das Ereignis auf dem Bildschirm angezeigt werden soll.`)
};

const it_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento selezionato da cronometrare. Tieni premuto il tasto freccia su per il tempo per cui desideri che l'evento venga visualizzato sullo schermo.`)
};

const ru_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите событие, которое нужно отследить по времени. Удерживайте клавишу со стрелкой вверх в течение времени, которое вы хотите, чтобы событие отображалось на экране.`)
};

const es_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento seleccionado que se cronometrará. Mantenga presionada la flecha hacia arriba durante el tiempo que desee que el evento se muestre en pantalla.`)
};

const zh_cn2_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要计时的事件。按住向上箭头键，直到事件在屏幕上显示所需的时间结束。`)
};

const ja_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントの時間を計測します。イベントを画面に表示したい時間だけ上矢印キーを押し続けます。`)
};

const hi_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय निर्धारित करने के लिए चयनित इवेंट। इवेंट को स्क्रीन पर प्रदर्शित करने के लिए आवश्यक समय तक ऊपर वाले तीर के बटन को दबाए रखें।`)
};

const pt_pt2_timing_sync_selected_event_tooltip = /** @type {(inputs: Timing_Sync_Selected_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o evento que deseja cronometrar. Mantenha pressionada a tecla de seta para cima durante o período de tempo que deseja que o evento seja exibido na tela.`)
};

/**
* | output |
* | --- |
* | "The selected event to be timed. Hold down the up arrow key for the duration of time you want the event to display on screen." |
*
* @param {Timing_Sync_Selected_Event_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_selected_event_tooltip = /** @type {((inputs?: Timing_Sync_Selected_Event_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Selected_Event_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_selected_event_tooltip(inputs)
	if (locale === "de") return de_timing_sync_selected_event_tooltip(inputs)
	if (locale === "it") return it_timing_sync_selected_event_tooltip(inputs)
	if (locale === "ru") return ru_timing_sync_selected_event_tooltip(inputs)
	if (locale === "es") return es_timing_sync_selected_event_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_selected_event_tooltip(inputs)
	if (locale === "ja") return ja_timing_sync_selected_event_tooltip(inputs)
	if (locale === "hi") return hi_timing_sync_selected_event_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_selected_event_tooltip(inputs)
	return en_timing_sync_selected_event_tooltip(inputs)
});